import { FaInfoCircle } from "react-icons/fa";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type Props = {
	totalAttendances: number;
	totalAttendancesClassificated: number;
	totalAttendancesClassifiedOnce: number;
	totalAttendancesClassifiedMoreThanOnce: number;
	totalAttendancesUnclassified: number;
	totalEvasions: number;
	percentageEvasions: number;
};

export function RiskClassificationDashboardCards({
	totalAttendances,
	totalAttendancesClassificated,
	totalAttendancesClassifiedOnce,
	totalAttendancesClassifiedMoreThanOnce,
	totalAttendancesUnclassified,
	totalEvasions,
	percentageEvasions,
}: Props) {
	return (
		<Row className="px-0 py-2 bg-white justify-content-evenly rounded">
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Total de atendimentos"
					value={totalAttendances.toLocaleString()}
					classNameCard="m-2 rounded p-2 bg-primary h-100"
					classNameTitle="text-white text-center"
					classNameValue="text-white"
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-white" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Atendimentos classificados"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					value={totalAttendancesClassificated.toLocaleString()}
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Atendimentos sem reclassificação"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={totalAttendancesClassifiedOnce.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Atendimentos reclassificados"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={`${totalAttendancesClassifiedMoreThanOnce.toLocaleString()}`}
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Atendimentos sem classificação"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={`${totalAttendancesUnclassified.toLocaleString()}`}
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Evasões da classificação"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={`${totalEvasions.toLocaleString()}`}
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="% de evasões na classificação"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={`${percentageEvasions.toLocaleString()} %`}
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
		</Row>
	);
}
